"use client";
import { FiPhone, FiMail } from "react-icons/fi";
import Image from "next/image";

const Getintouch = () => {
  return (
    <div>
      <section className=" relative py-16 ">
        <Image
          src="/images/phone.jpg"
          alt="Background Image"
          fill
          className="absolute top-0 left-0 w-full h-36 object-cover -z-10"
        />
        <div className="max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-20">
          {/* Contact Form */}
          <div className="">
            <form className="space-y-6">
              <input
                type="text"
                placeholder="Company Name"
                className="w-full p-4 bg-blue-50  rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:text-black"
              />
              <input
                type="email"
                placeholder="Email Address"
                className="w-full p-4 bg-blue-50 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:text-black"
              />
              <input
                type="text"
                placeholder="Phone Number"
                className="w-full p-4 bg-blue-50  rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:text-black"
              />
              <textarea
                placeholder="Message"
                rows="5"
                className="w-full p-4 bg-blue-50  rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:text-black"
              />
              <button
                type="submit"
                className="w-52 py-3 bg-blue-900 text-white font-bold hover:bg-blue-800"
              >
                Send Message
              </button>
            </form>
          </div>

          {/* Contact Information */}
          <div className="flex flex-col  w-1/2 justify-center space-y-6 -mt-28">
            <h2 className="text-4xl font-bold text-gray-900">CONTACT US</h2>
            <div className="flex items-center space-x-4">
              <FiPhone className="text-white w-10 h-10  bg-blue-900  rounded-full p-2" />
              <div>
                <p className="text-black font-semibold">+91 89760 06208</p>
                <hr className="border-dotted border-gray-400 mt-1" />
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <FiMail className="text-white w-10 h-10  bg-blue-900  rounded-full p-2" />
              <div>
                <p className="text-black font-semibold"></p>
                <hr className="border-dotted border-gray-400 mt-1" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Getintouch;
